import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H2 } from '@r1-frontend/ui-react/components/typography/heading';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Wrap = styled.div`
    flex-direction: column;
    margin-left: 32px;
    position: relative;
    width: 100%;
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-left: 0;
    }
`;

export const DetailText = styled.div`
    display: block;
    word-break: break-word;
    ${FONTS.L};
    color: ${COLORS.TextSecondary};

    & h1, h2, h3, h4, h5, h6 {
        margin-bottom: 8px;
        margin-top: 40px;
    }

    & h1 {
        ${FONTS.H2};

        @media (min-width: ${wideBreakpoints.mobile}) {
            ${FONTS.H0};
        }
    }
    
    & h2 {
        ${FONTS.H3};

        @media (min-width: ${wideBreakpoints.mobile}) {
            ${FONTS.H2};
        }
    }
    
    & h3 {
        ${FONTS.H4};

        @media (min-width: ${wideBreakpoints.mobile}) {
            ${FONTS.H3};
        }
    }

    & h4 {
        ${FONTS.H5};
    }
    
    & h5, h6 {
        ${FONTS.H6};
    }

    & a {
        color: ${COLORS.Link};
    }
    
    & div, p {
        display: block;
        vertical-align: top;
    }

    blockquote {
        margin: 40px;
    }
    
    & p {
        margin-top: 16px;
    }

    & ul, ol, table {
        margin-top: 40px;
    }
    
    td {
        padding-bottom: 12px;
    }

    & ul {
        list-style: disc;
        padding-left: 20px;
    }

    & ol {
        list-style: decimal;
        padding-left: 12px;
    }
    
    & li > * {
        vertical-align: top;
    }
    
    & li:last-child {
        margin-bottom: 0;
    }

    & img {
        max-width: 100%;
        height: auto;
        object-fit: contain;
        margin-bottom: 25px;
    }

    & > :first-child {
         margin-top: 0;
    }
    
     > table {
         max-width: 100%;
         width: 100% !important;
     }
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.S};
        
        & h1, h2, h3, h4, h5, h6 {
            margin-top: 12px;
        }
        & ol, & ul,  & p {
            margin-top: 8px;
        }
    }
`;

export const ArticleTitle = styled(H2)`
    margin-bottom: 16px;
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-bottom: 8px;
    }
`;
